var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBankJcb = function SvgBankJcb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 24,
    viewBox: "0 0 31 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3368_7459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0303 19.081C31.0303 21.7364 28.868 23.8986 26.2126 23.8986H0V4.81766C0 2.16226 2.16226 0 4.81766 0H31.0303V19.081Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4951 14.1875H24.4866C24.5435 14.1875 24.6763 14.1685 24.7332 14.1685C25.1125 14.0926 25.435 13.7512 25.435 13.277C25.435 12.8218 25.1125 12.4804 24.7332 12.3856C24.6763 12.3666 24.5625 12.3666 24.4866 12.3666H22.4951V14.1875Z",
    fill: "url(#paint0_linear_3368_7459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.259 1.61221C22.3623 1.61221 20.807 3.14855 20.807 5.06424V8.64904H25.6816C25.7954 8.64904 25.9281 8.64904 26.023 8.668C27.1231 8.7249 27.9387 9.29392 27.9387 10.2802C27.9387 11.0579 27.3886 11.7217 26.3644 11.8545V11.8924C27.4834 11.9683 28.337 12.5942 28.337 13.5615C28.337 14.6047 27.3886 15.2875 26.1368 15.2875H20.788V22.3054H25.8523C27.749 22.3054 29.3043 20.7691 29.3043 18.8534V1.61221H24.259Z",
    fill: "url(#paint1_linear_3368_7459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1884 10.5078C25.1884 10.0526 24.866 9.74913 24.4866 9.69223C24.4487 9.69223 24.3538 9.67326 24.2969 9.67326H22.4951V11.3424H24.2969C24.3538 11.3424 24.4676 11.3424 24.4866 11.3234C24.866 11.2665 25.1884 10.963 25.1884 10.5078Z",
    fill: "url(#paint2_linear_3368_7459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.17802 1.61221C3.28131 1.61221 1.726 3.14855 1.726 5.06424V13.5805C2.69332 14.0547 3.69858 14.3582 4.70385 14.3582C5.89878 14.3582 6.54366 13.6374 6.54366 12.6511V8.63007H9.50254V12.6321C9.50254 14.1875 8.53521 15.4583 5.25389 15.4583C3.26234 15.4583 1.70703 15.022 1.70703 15.022V22.2864H6.77127C8.66799 22.2864 10.2233 20.7501 10.2233 18.8344V1.61221H5.17802Z",
    fill: "url(#paint3_linear_3368_7459)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7185 1.61221C12.8218 1.61221 11.2665 3.14855 11.2665 5.06424V9.57843C12.139 8.83871 13.6563 8.36453 16.1031 8.47833C17.4118 8.53523 18.8154 8.89561 18.8154 8.89561V10.3561C18.1136 9.99571 17.2791 9.67326 16.1979 9.59739C14.3392 9.46462 13.2201 10.375 13.2201 11.9683C13.2201 13.5805 14.3392 14.4909 16.1979 14.3392C17.2791 14.2633 18.1136 13.9219 18.8154 13.5805V15.041C18.8154 15.041 17.4308 15.4014 16.1031 15.4583C13.6563 15.5721 12.139 15.0979 11.2665 14.3582V22.3244H16.3307C18.2274 22.3244 19.7827 20.788 19.7827 18.8723V1.61221H14.7185Z",
    fill: "url(#paint4_linear_3368_7459)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3368_7459",
    x1: 20.8038,
    y1: 13.2793,
    x2: 29.3272,
    y2: 13.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3368_7459",
    x1: 20.8036,
    y1: 11.9505,
    x2: 29.3276,
    y2: 11.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3368_7459",
    x1: 20.8036,
    y1: 10.5054,
    x2: 29.3273,
    y2: 10.5054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2285,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7433,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3368_7459",
    x1: 1.72198,
    y1: 11.9505,
    x2: 10.3773,
    y2: 11.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4751,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8261,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3368_7459",
    x1: 11.2174,
    y1: 11.9505,
    x2: 19.6237,
    y2: 11.9505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1735,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5731,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8585,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3368_7459"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBankJcb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bank-jcb.e6b10730e2310b730f5f0d4b08e8cd9d.svg";